import type { User } from '@ztechapps/common.contract'
import type { TemplateVariables } from './Context'
import filter from 'lodash/filter'
import map from 'lodash/map'

/**
 * This will just populate the template variables, based on the parent (e.g. salesOrder) if the child variables has no value
 * For backward compatibility
 * @param templateVariables
 */
export const useBuildDefaultTemplateVariables = ({
  salesOrder,
  trackingNumbers,
  trackingNumbersWithUrl,
  resetUsersPassword,
  ...rest
}: TemplateVariables): TemplateVariables => {
  //build the default tracking numbers — packages without a tracking number carry nothing to show
  const packagesWithTracking = filter(salesOrder?.shipping?.packages, (item) => !!item?.tracking_number)
  trackingNumbers = trackingNumbers ?? map(packagesWithTracking, (item) => item?.tracking_number)?.join(' , ') ?? ''

  //build the default tracking numbers with url — no tracking url means plain text, never href=undefined
  trackingNumbersWithUrl =
    trackingNumbersWithUrl ??
    map(packagesWithTracking, (item) =>
      item?.trackingUrl
        ? `<a href="${item.trackingUrl}" target="_blank">${item.tracking_number}</a>`
        : (item?.tracking_number as string)
    )?.join(' , ') ??
    ''

  //build the default resetUsersPassword, using the sales orders members — absent by/member rows stay out, never phantom options
  resetUsersPassword = resetUsersPassword ?? [
    ...(salesOrder?.by?._id
      ? [{ ...(salesOrder.by as User), value: salesOrder.by?._id, label: salesOrder.by?.profile?.name }]
      : []),
    ...map(
      filter(salesOrder?.members, (item) => !!item?._id),
      (item) => ({ ...item, value: item?._id, label: item?.profile?.name })
    ),
  ]

  return {
    ...rest,
    salesOrder,
    trackingNumbers,
    trackingNumbersWithUrl,
    resetUsersPassword,
  }
}
